function _convertQuery(query) {
  try {
    const outStr = JSON.stringify(query).replace(
      /"id":"(.*?)"/g,
      '"_id": {"$oid": "$1"}',
    );

    return JSON.parse(outStr);
  } catch (ex) {
    return query;
  }
}

function _convertDocument(doc) {
  if (doc._id) {
    doc.id = doc._id?.$oid;
    delete doc._id;
  }
  return doc;
}

export {_convertQuery, _convertDocument};
